import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobile } from '@fortawesome/free-solid-svg-icons';

export default function Real_Estate_Reg_Fee() {
  return (
    <div  className='inner_TC_MAIN'>
    <div className='Main_MPESA_inner'>
      <FontAwesomeIcon icon={faMobile} className='phoneMpesa' />
      <p className='fee'>Pay regestration fee of Ksh 1000 via mpesa</p>
      <p className='total_fee'>Total: Ksh.1000</p>

      <div className='T_C_Buttons'>
       <button className='acc_BTN'>pay</button>
       <button className='dec_BTN'>don't pay</button>
    </div>
   </div>
   
   </div>
  )
}
